import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry";

// Inicializa Sentry antes de qualquer outro código
initSentry();

// Patch console first to filter logs globally
import "./utils/logControl";
import "./utils/registerEuiIcons";
import App from "./App.tsx";
import "./index.css";

// Importar configuração de datas ANTES de qualquer outro código
import "./utils/dateConfig";

// Get the root element
const rootElement = document.getElementById("root");

// Make sure the root element exists
if (!rootElement) throw new Error("Failed to find the root element");

// Create a root and render the App
createRoot(rootElement).render(<App />);
